import React, {useEffect, useRef, useState, useContext} from 'react'
import BarcodeLabelDropArea from '../BarcodeLabelDropArea'
import useStyles from './BarcodeLabelWorkSpace.styles'
import {BarcodeLabelEditorContext} from '../../context/BarcodeLabelEditor'

const BarcodeLabelWorkSpace = ({width, height}) => {
  const classes = useStyles()
  const refRoot = useRef(null)
  const {deselectAllItem} = useContext(BarcodeLabelEditorContext)

  const [dummyPos, setDummyPos] = useState({top: 0, left: 0})
  const [expanderDim, setExpanderDim] = useState({width: 0, height: 0})
  const [scroll, setScroll] = useState({top: 0, left: 0})

  const handleClick = e => {
    if (e.target.dataset && e.target.dataset.canDeselect === 'true') {
      // remove focus to current active element
      document.activeElement.blur()
      //
      deselectAllItem()
    }
  }

  useEffect(() => {
    if (isNaN(width * 1) || isNaN(height * 1)) {
      return
    }
    // get expander width and height
    const expander = {
      width: width + 500,
      height: height + 500,
    }

    // set position of dummy container to center
    const dummyPos = {
      top: expander.height / 2 - height / 2,
      left: expander.width / 2 - width / 2,
    }

    // get real width and height for make it a view port
    const rootRect = refRoot.current.getBoundingClientRect()

    // adjust scroll to make the drop area center
    const scroll = {
      top: expander.height / 2 - rootRect.height / 2,
      left: expander.width / 2 - rootRect.width / 2,
    }

    setExpanderDim(expander)
    setDummyPos(dummyPos)
    setScroll(scroll)
  }, [width, height])

  useEffect(() => {
    refRoot.current.scrollTo(scroll.left, scroll.top)
  }, [scroll])

  return (
    <div ref={refRoot} className={classes.root} data-can-deselect={true} onClick={handleClick}>
      <div className={classes.expander} style={expanderDim} data-can-deselect={true}>
        <div className={classes.dummyContainer} style={dummyPos} data-can-deselect={true}>
          <BarcodeLabelDropArea width={width} height={height} />
        </div>
      </div>
    </div>
  )
}

export default BarcodeLabelWorkSpace
